import * as React from 'react';
import { gql, useMutation } from '@apollo/client';
import { DirectUpload } from '../components/media/DirectUpload';

// Mutation para criar ou atualizar um curso, mas com uma String para o campo de vídeo
// ao invés de um Upload
const UPDATE_COURSE_MUTATION = gql`
  mutation createOrUpdateCourse(
    $id: ID
    $title: String!
    $status: String
    $description: String!
    $premiumAccessThroughAnyPlan: Boolean
    $courseCategoryId: ID
    $programIds: [ID!]
    $cover: String
    $poster: String
  ) {
    course(
      input: {
        id: $id
        title: $title
        status: $status
        description: $description
        premiumAccessThroughAnyPlan: $premiumAccessThroughAnyPlan
        courseCategoryId: $courseCategoryId
        programIds: $programIds
        cover: $cover
        poster: $poster
      }
    ) {
      course {
        id
        title
        description
      }
    }
  }
`;

export const DirectUploadExample = () => {
  const [courseData, setCourseData] = React.useState({
    title: '',
    description: '',
    coverUrl: '',
    posterUrl: ''
  });
  
  const [updateCourse, { loading, error }] = useMutation(UPDATE_COURSE_MUTATION);
  
  const handleCoverUploadComplete = (url: string) => {
    setCourseData({ ...courseData, coverUrl: url });
  };
  
  const handlePosterUploadComplete = (url: string) => {
    setCourseData({ ...courseData, posterUrl: url });
  };
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const result = await updateCourse({
        variables: {
          title: courseData.title,
          description: courseData.description,
          cover: courseData.coverUrl,
          poster: courseData.posterUrl
        }
      });
      
      console.log('Curso atualizado:', result.data);
      // Redirecionar ou mostrar mensagem de sucesso
      
    } catch (error) {
      console.error('Erro ao atualizar curso:', error);
    }
  };
  
  return (
    <div className="container">
      <h4>Criar Novo Curso</h4>
      
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="input-field col s12">
            <input
              id="title"
              type="text"
              value={courseData.title}
              onChange={(e) => setCourseData({ ...courseData, title: e.target.value })}
              required
            />
            <label htmlFor="title">Título</label>
          </div>
        </div>
        
        <div className="row">
          <div className="input-field col s12">
            <textarea
              id="description"
              className="materialize-textarea"
              value={courseData.description}
              onChange={(e) => setCourseData({ ...courseData, description: e.target.value })}
              required
            />
            <label htmlFor="description">Descrição</label>
          </div>
        </div>
        
        <div className="row">
          <div className="col s12 m6">
            <h6>Imagem de Capa</h6>
            <DirectUpload
              onUploadComplete={handleCoverUploadComplete}
              mediaType="image"
              folder="courses/covers"
            />
            {courseData.coverUrl && (
              <p className="green-text">Imagem de capa enviada com sucesso!</p>
            )}
          </div>
          
          <div className="col s12 m6">
            <h6>Pôster</h6>
            <DirectUpload
              onUploadComplete={handlePosterUploadComplete}
              mediaType="image"
              folder="courses/posters"
            />
            {courseData.posterUrl && (
              <p className="green-text">Pôster enviado com sucesso!</p>
            )}
          </div>
        </div>
        
        <div className="row">
          <div className="col s12">
            <button
              type="submit"
              className="btn waves-effect waves-light"
              disabled={loading || !courseData.title || !courseData.description}
            >
              Salvar Curso
              <i className="material-icons right">send</i>
            </button>
            
            {loading && <div className="progress"><div className="indeterminate"></div></div>}
            
            {error && (
              <div className="card-panel red lighten-4">
                <span className="red-text text-darken-4">Erro ao salvar: {error.message}</span>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}; 